import * as types from './types';

export default {    
    [types.ZIPCODE]: state => {
        //Return zipcode
        return state.VuexZipcode;
    },
    [types.RENTALCONTAINERSLIST]: state => {
        //Return products list.
        return state.VuexRentalContainersList;
    },
    [types.DOORDIRECTION]: state => {
        //Predelivery door direction user input
        return state.VuexPredelivery.doordirection;
    },
    [types.DELIVERYSPACE]: state => {
        //Predelivery space user input
        return state.VuexPredelivery.deliveryspace;
    },
    [types.CONTAINERCONDITION]: state => {
        //Predelivery container condition user input
        return state.VuexPredelivery.containercondition;
    },
    [types.TWOMONTHS]: state => {
        //Predelivery two months agreement
        return state.VuexPredelivery.twomonths;
    },
    [types.DELIVERYINSTRUCTIONS]: state => {
        //Predelivery additional comments
        return state.VuexPredelivery.deliveryinstructions;
    },
    [types.DELIVERYCONTACTNAME]: state => {
        //Predelivery contact name
        return state.VuexPredelivery.deliveryname;
    },
    [types.DELIVERYCONTACTPHONE]: state => {
        //Predelivery contact phone number
        return state.VuexPredelivery.deliveryphone;
    },
    [types.CARTLINEITEM]: state => {
        //Return item in the cart(Always one)
        return state.VuexCartItem;
    },    
    [types.UNACCEPTABLEDATES]: state => {
        //Dats users do not want containers to be delivered.
        return state.VuexPredelivery.nonacceptabledates;
    },    
    [types.TERMSNCONDITIONS]: state => {
        //terms and conditions acknowledgement
        return state.terms_conditions;
    },
    [types.PREDELIVERYANSWERS]: state => {
        //Profile Questions Answers
        return state.VuexPredelivery;
    },
    [types.MOVECONTAINERS]: state => {
        //Predelivery move loaded contaienrs acknowledgment
        return state.VuexPredelivery.movecontainers;
    },
    [types.RENTALSDURATION]: state => {
        //Rentals duration input by user
        return state.VuexPredelivery.rentalsduration;
    },    
    [types.DELIVERYSURFACETYPE]: state => {
        //Delivery surface - 'Hard/Soft'
        return state.VuexPredelivery.deliverysurfacetype;
    },
    [types.SOFTSURFACEACKNOWLEDGE]: state => {
        //return SOFT SURFACE acknowledgement
        return state.VuexPredelivery.softSurfaceAcknowledge;
    },
    [types.COUNTRY_CODE]: state => {
        //return COUNTRY CODE
        return state.country_code;
    },
};